// LIBRARY
import { toast } from "react-toastify"
import React, { Component } from "react"
import Cookies from "universal-cookie"
import Swal from "sweetalert2"

import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

import { format_date } from "../components/CustomComponent"

// CSS
import "./css/style.css"
import "./css/bootstrap.css"
import "react-toastify/dist/ReactToastify.css"
import "react-pro-sidebar/dist/css/styles.css"
import "@trendmicro/react-sidenav/dist/react-sidenav.css"

const cookies = new Cookies()
toast.configure()

export default class HeaderComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal_in_and_out_ward: false,
      modal_internal_parcel: false,
      modal_external_parcel: false,
      modal_in_and_out: false,
      modal_carrying: false,
      modal_service: false,
      start_date: "",
      end_date: "",
      type: "พัสดุธรรมดา",
      project: "",
      agency: "",
      project_all_list:  cookies.get("user_profile")?.agency_list || null,
      agency_all_list: [],
      token: cookies.get("token") ? "token " + cookies.get("token") : "",
    }
  }

  componentDidMount() {
    const { project_all_list } = this.state;
    var user = cookies.get("user_profile")
    if (user.role_data.role_name === "system_admin") {
      this.get_Project()
    } else {
      const profile = cookies.get("user_profile");

this.setState(prevState => {
  const exists = prevState.project_all_list.some(
    item => item.agency_id === profile?.agency_id
  );

  if (exists) {
    return null; // ❌ ไม่เพิ่ม ถ้ามีแล้ว
  }

  return {
    project_all_list: [
      ...prevState.project_all_list,
      {
        agency_id: profile?.agency_id,
        agency_name: profile?.agency_name,
        project_id: profile?.project_id,
        project_name: profile?.project_name,
      }
    ]
  };
});
    }
  }

  alert(icon, title, detail) {
    Swal.fire({
      icon: icon,
      title: title,
      text: detail,
      confirmButtonText: "ตกลง",
    })
  }

  clear_form() {
    this.setState({
      modal_in_and_out_ward: false,
      modal_internal_parcel: false,
      modal_external_parcel: false,
      modal_in_and_out: false,
      modal_carrying: false,
      modal_service: false,
      start_date: "",
      end_date: "",
      type: "พัสดุธรรมดา",
      project: "",
      agency: "",
    })
  }

  in_and_out_ward() {
    if (
      this.state.token &&
      this.state.start_date &&
      this.state.end_date &&
      this.state.project &&
      this.state.agency
    ) {
      window.open(
        global.api +
          "v1/in-out-ward/on-web/export/" +
          this.state.token +
          "/" +
          this.state.start_date +
          "/" +
          this.state.end_date +
          "/" +
          this.state.project +
          "/" +
          this.state.agency,
        "_blank"
      )
      this.clear_form()
    } else {
      this.alert("info", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน")
    }
  }
  internal_parcel() {
    if (
      this.state.token &&
      this.state.start_date &&
      this.state.end_date &&
      this.state.project &&
      this.state.agency
    ) {
      window.open(
        global.api +
          "v1/internal-package/export/" +
          this.state.token +
          "/" +
          this.state.start_date +
          "/" +
          this.state.end_date +
          "/" +
          this.state.project +
          "/" +
          this.state.agency,
        "_blank"
      )
      this.clear_form()
    } else {
      this.alert("info", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน")
    }
  }
  external_parcel() {
    if (
      this.state.token &&
      this.state.start_date &&
      this.state.end_date &&
      this.state.project &&
      this.state.agency
    ) {
      window.open(
        global.api +
          "v1/external-package/export/" +
          this.state.token +
          "/" +
          this.state.start_date +
          "/" +
          this.state.end_date +
          "/" +
          this.state.project +
          "/" +
          this.state.agency,
        "_blank"
      )
      this.clear_form()
    } else {
      this.alert("info", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน")
    }
  }
  in_and_out() {
    if (
      this.state.token &&
      this.state.start_date &&
      this.state.end_date &&
      this.state.project &&
      this.state.agency
    ) {
      window.open(
        global.api +
          "v1/in-out-area/on-web/export/" +
          this.state.token +
          "/" +
          this.state.start_date +
          "/" +
          this.state.end_date +
          "/" +
          this.state.project +
          "/" +
          this.state.agency,
        "_blank"
      )
      this.clear_form()
    } else {
      this.alert("info", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน")
    }
  }
  carrying() {
    if (
      this.state.token &&
      this.state.start_date &&
      this.state.end_date &&
      this.state.project &&
      this.state.agency
    ) {
      window.open(
        global.api +
          "v1/move-things/on-web/export/" +
          this.state.token +
          "/" +
          this.state.start_date +
          "/" +
          this.state.end_date +
          "/" +
          this.state.project +
          "/" +
          this.state.agency,
        "_blank"
      )
      this.clear_form()
    } else {
      this.alert("info", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน")
    }
  }
  async service() {
    const {token, start_date, end_date, project, agency} = this.state;
    if ( token && start_date && end_date && project && agency ) {
      const headers = { "Content-Type": "application/json", accept: "application/json", Authorization: token };
       // page แรก
      const res = await fetch(`${global.api}v1/call-service/transaction?page=1&project_id=${project}&agency_id=${agency}&start_date=${start_date}&end_date=${end_date}`, { headers });
      const result_notify = await res.json();

      let transaction = [...result_notify.data.data];
      const totalPages = result_notify.data.page_number;

      // สร้าง request สำหรับหน้าที่เหลือ
      const requests = [];
      for (let i = 2; i <= totalPages; i++) {
        requests.push(fetch(`${global.api}v1/call-service/transaction?page=${i}&project_id=${project}&agency_id=${agency}&start_date=${start_date}&end_date=${end_date}`, { headers }).then(r => r.json()).then(j => j.data.data));
      }

      // ยิงพร้อมกัน
      const results_notify = await Promise.all(requests);
      // รวมข้อมูล
      transaction.push(...results_notify.flat()); 
      transaction = transaction.map(item => ({
        "REQ ID": item.running_number,	
        "เวลาที่แจ้ง": item.service_start_at ? format_date(item.service_start_at,"dd/mm/yyyy hh:mm:ss") : "",
        "เวลาที่ปิดงาน": item.service_end_at ? format_date(item.service_end_at,"dd/mm/yyyy hh:mm:ss") : "",
        "ประเภทบริการ": item.service_name,
        "โครงการ": item.project_name,
        "หน่วยงาน": item.agency_name,
        "จุดบริการ": item.name,
        "ผู้รับเรื่อง": item.assignee_name,
        "สถานะ": item.status,
        "หมายเหตุ": item.description
      }))

      // 1. Convert JSON to worksheet
      const worksheet = XLSX.utils.json_to_sheet(transaction);

      // 2. Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 3. Write the workbook to binary buffer
      const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});

      // 4. Save to file
      const data = new Blob([excelBuffer], {type: "application/octet-stream"});
      saveAs(data, `รายงานบริการ-${start_date}-${end_date}.xlsx`);

      this.clear_form()
    } else {
      this.alert("info", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน")
    }
  }
  get_Project() {
    this.setState({ loading: true })
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
    }
    fetch(global.api + "v1/project/all", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ project_all_list: result.data.data })

          this.setState({ loading: false })
        } else {
          switch (result.data.detail) {
            case "":
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }
  get_Agency(id) {
    this.setState({ loading: true })
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        project_id: id,
      }),
    }
    fetch(global.api + "v1/project/agency", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ agency_all_list: result.data.data })
          this.setState({ loading: false })
        } else {
          switch (result.data.detail) {
            case "":
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  render() {
    return (
      <div className="w-100 d-flex justify-content-between p-4 mt-5 ">
        <h2 className="mt-4 w-100 ">
          <b>{this.props.header}</b>
        </h2>
        {this.props.report === "true" && (
          <button
            className="btn btn-primary px-3 "
            onClick={() => {
              this.clear_form()
              switch (this.props.header) {
                case "เข้า-ออกวอร์ด": this.setState({ modal_in_and_out_ward: true }); break;
                case "จดหมายและพัสดุ": this.setState({ modal_internal_parcel: true }); break;
                case "พัสดุภายนอก": this.setState({ modal_external_parcel: true }); break;
                case "เข้า-ออกพื้นที่": this.setState({ modal_in_and_out: true }); break;
                case "ขนของเข้า-ออก": this.setState({ modal_carrying: true }); break;
                case "รายการคำขอ": this.setState({ modal_service: true }); break;
                case "รายงานบริการ": this.setState({ modal_service: true }); break;
                default:; break;
              }
              this.setState({ sidebar: !this.state.sidebar })
            }}
          >
            <span className="icon mr-2">{"\uf33d"}</span>ออกรายงาน
          </button>
        )}
        {/* modal */}
        <div
          className={
            this.state.modal_in_and_out_ward ||
            this.state.modal_internal_parcel ||
            this.state.modal_external_parcel ||
            this.state.modal_in_and_out ||
            this.state.modal_carrying ||
            this.state.modal_service
              ? "show-modal"
              : "hide-modal"
          }
        >
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.clear_form()
            }}
          ></div>
          <div
            className={
              this.state.modal_in_and_out_ward ||
              this.state.modal_internal_parcel ||
              this.state.modal_external_parcel ||
              this.state.modal_in_and_out ||
              this.state.modal_carrying ||
              this.state.modal_service
                ? "box-modal p-4"
                : "hide-box-modal p-4"
            }
          >
            <div className="d-flex justify-content-between">
              <h3>
                <b>ออกรายงาน</b>
              </h3>
              <button
                className="btn btn-link d-block d-md-none"
                onClick={() => {
                  this.clear_form()
                }}
              >
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>
            {/* วันที่เริ่มต้น */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-3 col-xl-3 col-lg-3">
                <span>วันที่เริ่มต้น:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-9 col-xl-9 col-lg-9">
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ start_date: e.target.value })
                  }}
                  value={this.state.start_date}
                ></input>
              </div>
            </div>
            {/* วันที่สิ้นสุด */}
            <div className="row mt-3">
              <div className="col-12 col-sm-12 col-md-3 col-xl-3 col-lg-3">
                <span>วันที่สิ้นสุด:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-9 col-xl-9 col-lg-9">
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ end_date: e.target.value })
                  }}
                  value={this.state.end_date}
                ></input>
              </div>
            </div>
            <hr />
            {/* โครงการ */}
            <div className="row mt-3">
              <div className="col-12 col-sm-12 col-md-3 col-xl-3 col-lg-3">
                <span>โครงการ:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-9 col-xl-9 col-lg-9">
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ project: e.target.value })
                    if (e.target.value === "") {
                      this.setState({ agency_all_list: [], project: "" })
                    } else {
                      this.get_Agency(e.target.value)
                    }
                  }}
                  value={this.state.project}
                >
                  <option value="">-- เลือกโครงการ --</option>
                  {this.state.project_all_list &&
                    this.state.project_all_list.map((project, index) => (
                      <option key={index} value={project.project_id}>
                        {project.project_name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {/* หน่วยงาน */}
            <div className="row mt-3">
              <div className="col-12 col-sm-12 col-md-3 col-xl-3 col-lg-3">
                <span>หน่วยงาน:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-9 col-xl-9 col-lg-9">
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ agency: e.target.value })
                  }}
                  value={this.state.agency}
                >
                  <option value="">-- เลือกหน่วย --</option>
                  {this.state.agency_all_list &&
                    this.state.agency_all_list.map((agency, index) => (
                      <option value={agency.agency_id}>
                        {agency.agency_name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <hr />
            {/* ปุ่ม */}
            <div className="row">
              <div className="col-12 col-sm-12 col-md-9 col-xl-9 col-lg-9 ml-auto">
                <div className="row ">
                  <div className="col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3">
                    <button
                      className="btn btn-secondary w-100"
                      onClick={() => {
                        this.clear_form()
                      }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3">
                    <button
                      className="btn btn-primary w-100"
                      onClick={() => {
                        switch (this.props.header) {
                          case "เข้า-ออกวอร์ด": this.in_and_out_ward(); break; 
                          case "จดหมายและพัสดุ": this.internal_parcel(); break; 
                          case "พัสดุภายนอก": this.external_parcel(); break; 
                          case "เข้า-ออกพื้นที่": this.in_and_out(); break; 
                          case "ขนของเข้า-ออก": this.carrying(); break; 
                          case "รายการคำขอ": this.service(); break; 
                          case "รายงานบริการ": this.service(); break; 
                          default: break;
                        }
                      }}
                    >
                      <span className="icon mr-2">{"\uf063"}</span>ดาวน์โหลด
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
